'use client'

import { useLanguage } from '@/app/LanguageContext'

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage()

  return (
    <div className="flex items-center gap-1 px-2 py-1 rounded-md border border-[#E2E4E5] bg-white">
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 text-sm font-medium rounded transition-colors duration-140 ${
          language === 'en'
            ? 'bg-[#003F47] text-white'
            : 'text-[#6C7377] hover:text-[#003F47]'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <div className="text-[#E2E4E5]">|</div>
      <button
        onClick={() => setLanguage('ar')}
        className={`px-3 py-1 text-sm font-medium rounded transition-colors duration-140 ${
          language === 'ar'
            ? 'bg-[#003F47] text-white'
            : 'text-[#6C7377] hover:text-[#003F47]'
        }`}
        aria-label="Switch to Arabic"
      >
        العربية
      </button>
    </div>
  )
}
